export function shouldReloadNavigation({
  source,
  currentRouteName,
  targetRouteName,
} = {}) {
  return source === 'menu-click' &&
    Boolean(currentRouteName) &&
    currentRouteName === targetRouteName
}

const TABLE_VIEW_STATE_QUERY_KEYS = new Set(['fileId', 'sheetIndex', 'rowId', 'cell', 'range', 'cells'])

export function isTableViewStateOnlyChange(to, from) {
  if (to?.name !== 'Table' || from?.name !== 'Table') return false
  if (!to.path || to.path !== from.path || to.hash !== from.hash) return false

  const nextQuery = to.query || {}
  const previousQuery = from.query || {}
  const queryKeys = new Set([...Object.keys(nextQuery), ...Object.keys(previousQuery)])
  return [...queryKeys].every(key => (
    TABLE_VIEW_STATE_QUERY_KEYS.has(key) ||
    JSON.stringify(nextQuery[key]) === JSON.stringify(previousQuery[key])
  ))
}

// Keep in-project query/child navigation alive, but discard the previous project's view.
export function getRouteViewKey(route) {
  if (route.name === 'AsyncTaskLogDetail') return route.path
  const projectRecord = route.matched?.find(record => record.meta?.projectContext)
  return projectRecord ? `${projectRecord.path}:${route.params.pk}` : undefined
}
